import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import { Button, Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import GenericSelection from '../../Common/GenericSelection';
import {
  ROOT_URL, ROOT_API_URL, isLAP, isUSPrideMulti, isAPD, isOLG, isSV, isEKC, isLMH, isBRO, isSDR, isGFD,
} from '../../../actions/root_url';

const initialState = {
  subject: '',
  content: '',
  phone: '',
  sendEmail: '',
}

const emailOptions = [
  {label: "Welleastflooring@gmail.com", value: "Welleastflooring@gmail.com"},
  {label: "Excellentflooring4400@gmail.com", value: "Excellentflooring4400@gmail.com"},
];

const emailOptionsSVPO = [
  {label: "jenny@gmail.com", value: "jenny@gmail.com"},
  {label: "lyn@gmail.com", value: "lyn@gmail.com"},
];

class EmailContentModal extends Component {
  constructor() {
    super();
    this.state = {
      ...initialState,
      selectedEmail: null,
      phone: '',
      vendorurl: '',
      sendEmail: '',
    };
    // this.subjectRef = React.createRef();
  }


  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({
        ...initialState,
        subject: this.props.subject,
        content: this.props.content,
      }, () => {
        // this.subjectRef.current.focus();
      })
    }
    if ((isOLG || (isLAP || isUSPrideMulti || isAPD) || isGFD || isBRO) && this.props.visible && !prevProps.visible) {
      if (this.props.selectedRows && this.props.selectedRows.length) {
        if (this.props.source === "PO") {
          this.state.vendorurl = `${ROOT_URL}v1/vendor/${this.props.selectedRows[0].Vendor_id}`;
          axios({
            method: 'GET',
            url: this.state.vendorurl,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          })
            .then(res => {
              if (res.data && res.data.Billing && res.data.Billing.Cellphone) {
                this.setState({ phone: res.data.Billing.Cellphone });
              } else {
                this.setState({ phone: ''});
              }
              if (res.data && res.data.Billing && res.data.Billing.Email) {
                this.setState({ sendEmail: res.data.Billing.Email });
              } else {
                this.setState({ sendEmail: '' });
              }
            }, err => {
            })
        }

        if (this.props.source === "SO" || this.props.source === "SQ" || this.props.source === "CS" || this.props.source === "SI" || this.props.source === "AR") {
          this.state.vendorurl = `${ROOT_URL}v1/sale/customer/${this.props.selectedRows[0].Deliver_Customer_id}`;
          if(this.props.source === "AR") {this.setState({sendEmail: '', phone: ''})}
          axios({
            method: 'GET',
            url: this.state.vendorurl,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          })
            .then(res => {
              if (this.props.source === "SQ") {
                if (res.data && res.data.Mailing && res.data.Mailing.Cellphone) {
                  this.setState({ phone: res.data.Mailing.Cellphone });
                }
                if (res.data && res.data.Mailing && res.data.Mailing.Email) {
                  this.setState({ sendEmail: res.data.Mailing.Email });
                }
              } else {
                if (res.data && res.data.Billing && res.data.Billing.Cellphone) {
                  this.setState({ phone: res.data.Billing.Cellphone });
                }
                if (res.data && res.data.Billing && res.data.Billing.Email) {
                  this.setState({ sendEmail: res.data.Billing.Email });
                }
              }
            }, err => {
            })
        }}
    }
  }

  handleSendClick = () => {
    let {selectedEmail}= this.state;
    let email = null;
    if (selectedEmail) {
      email =selectedEmail.value;
    }
    this.props.onConfirm(this.state.subject, this.state.content, email, this.state.phone, this.state.sendEmail, this.props.source);
  }

  handleInputChange = ({ target }) => {
    // preventDefault();
    // console.log('target', target)
    this.setState({
      [target.name]: target.value,
    })
  }

  handleDropdownChange = ( target ) => {
    this.setState({
      selectedEmail: target,
    })
  }

  render() {
    const {visible, onClose} = this.props;
    return <SkyLightStateless
      dialogStyles={styles.modal}
      isVisible={visible}
      onCloseClicked={onClose}
      title={'Send Content'}
    >
      <div style={styles.container}>
        <div className="panel panel-default" style={{overflowY: 'scroll', width: '100%', 'justifyContent': 'center', display: 'flex'}}>
          <div className="panel-body" style={{width: "100%"}}>
          {(isEKC || isLMH) &&
            <Row>
              <Col sm={2} alignContent="center">
                <label className="col-xs-3">from: </label>
              </Col>
              <Col sm={9}>
                <div className="email365">
                  <GenericSelection
                    options={emailOptions}
                    value={this.state.selectedEmail}
                    setSelected={(e) => {this.handleDropdownChange(e)}}
                  />
                </div>
              </Col>
            </Row>
          }
          {(isSV && this.props.source === 'PO') &&
            <Row>
              <Col sm={2} alignContent="center">
                <label className="col-xs-3">from: </label>
              </Col>
              <Col sm={9}>
                <div className="email365">
                  <GenericSelection
                    options={emailOptionsSVPO}
                    value={this.state.selectedEmail}
                    setSelected={(e) => {this.handleDropdownChange(e)}}
                  />
              </div>
            </Col>
          </Row>
        }
        {((isLAP || isUSPrideMulti || isAPD) || isGFD) &&
          <Row style={styles.row}>
            <Col sm={2} alignContent="center">
              <label className="col-xs-3">Phone: </label>
            </Col>
            <Col sm={9}>
              <input
                name='phone'
                className='form-control'
                value={this.state.phone}
                onChange={e => this.handleInputChange(e)}
                autoFocus
                // ref={subjectRef}
              />
              <div style={{ width: '100%', color: 'red' }}>
                {
                  this.state.error
                }
              </div>
            </Col>
          </Row>
        }
        {((isLAP || isUSPrideMulti || isAPD) || isGFD || isBRO) &&
          <Row style={styles.row}>
            <Col sm={2} alignContent="center">
              <label className="col-xs-3">Email: </label>
            </Col>
            <Col sm={9}>
              <input
                name='sendEmail'
                className='form-control'
                value={this.state.sendEmail}
                onChange={e => this.handleInputChange(e)}
                autoFocus
                // ref={subjectRef}
              />
              <div style={{ width: '100%', color: 'red' }}>
                {
                  this.state.error
                }
              </div>
            </Col>
          </Row>
        }
          <Row style={styles.row}>
            <Col sm={2} alignContent="center">
              <label className="col-xs-3">Subject: </label>
            </Col>
            <Col sm={9}>
              <input
                name='subject'
                className='form-control'
                value={this.state.subject}
                onChange={e => this.handleInputChange(e)}
                autoFocus
                // ref={subjectRef}
              />
              <div style={{ width: '100%', color: 'red' }}>
                { this.state.error }
              </div>
            </Col>
          </Row>
          <Row style={styles.row}>
            <Col sm={2} alignContent="center">
              <label className="col-xs-3">Content: </label>
            </Col>
            <Col sm={9}>
              <textarea
                // type="password"
                name='content'
                className='form-control'
                style={{ width: '100%', height: '220px', outline: 'none', padding: '10px', maxWidth: '100%', position: 'relative' }}
                value={this.state.content}
                onChange={e => this.handleInputChange(e)}
              />
              <div style={{ width: '100%', color: 'red' }}>
                { this.state.error }
              </div>
            </Col>
            <Col span={3} alignContent="center">
              {/* <Label translateValue="customer_name" suffix=":" /> */}
            </Col>
          </Row>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', }}>
          <Button
            classNames="btn-primary"
            onClick={this.handleSendClick}
          >
            <i className="fa fa-envelope" />
            <Translate value="send" />
          </Button>
        </div>
      </div>
    </SkyLightStateless>
  }
}

const styles = {
  modal: {
    width: '575px',
    height: '480px',
    marginLeft: '-9%',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  sectionPadding: {
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  row: {
    display: 'flex', flexDirection: 'row', marginBottom: '10px', alignItems: 'center'
  }
};

export default EmailContentModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/EmailContentModal.jsx